import { Link } from 'react-router-dom';
import { ArrowLeft, Calendar, Gift, Book } from 'lucide-react';

export default function ArtikelIslamischeBuecherKinder() {
  return (
    <main className="pt-20 md:pt-24 bg-[#FDFCF8]">
      <section className="py-16 md:py-24 bg-[#4A5D4F]">
        <div className="max-w-4xl mx-auto px-6 md:px-12">
          <Link to="/ratgeber" className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-8 transition-colors"><ArrowLeft className="w-4 h-4" />Alle Ratgeber</Link>
          <div className="flex items-center gap-2 text-[#D4C5A9] text-sm mb-4"><Calendar className="w-4 h-4" /><span>Februar 2026</span></div>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-medium text-white mb-6 leading-tight">Islamische Bücher für Kinder zu Ramadan & Eid</h1>
          <p className="text-lg text-white/80 leading-relaxed">Die schönsten Kinderbücher über den Islam, Ramadan und Eid – sortiert nach Alter.</p>
        </div>
      </section>
      <article className="py-16 md:py-20">
        <div className="max-w-3xl mx-auto px-6 md:px-12 prose prose-lg max-w-none">
          <p className="text-xl text-[#2C332E] leading-relaxed mb-8">Bücher sind ein wunderbares Geschenk zu Eid – sie unterhalten, bilden und vermitteln islamische Werte. Hier findest du die besten deutschsprachigen Kinderbücher für verschiedene Altersgruppen.</p>

          <section className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-[#D4C5A9]/30 flex items-center justify-center"><Book className="w-6 h-6 text-[#4A5D4F]" /></div>
              <h2 className="font-serif text-2xl font-medium text-[#2C332E]">Für Kleinkinder (2-5 Jahre)</h2>
            </div>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">"Mama, was ist Ramadan?"</h4>
                <p className="text-sm text-[#4B5563] mb-2">Ein liebevolles Buch, das Kleinkindern den Ramadan erklärt. 72 Seiten mit wunderschönen Illustrationen über Fasten, Geduld und Barmherzigkeit.</p>
                <p className="text-sm text-[#4A5D4F]">Alter: 3-8 Jahre | ~15€</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">"Mein erstes Buch über Eid"</h4>
                <p className="text-sm text-[#4B5563] mb-2">Stabiles Pappbuch mit einfachen Texten und bunten Bildern. Perfekt für die ersten Berührungen mit dem Thema Eid.</p>
                <p className="text-sm text-[#4A5D4F]">Alter: 2-4 Jahre | ~10€</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">"Der Ramadan-Mond"</h4>
                <p className="text-sm text-[#4B5563] mb-2">Ein Bilderbuch über ein Kind, das auf den Ramadan-Mond wartet. Sanfte Geschichte über Vorfreude und Familie.</p>
                <p className="text-sm text-[#4A5D4F]">Alter: 3-6 Jahre | ~12€</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-[#4A5D4F]/10 flex items-center justify-center"><Book className="w-6 h-6 text-[#4A5D4F]" /></div>
              <h2 className="font-serif text-2xl font-medium text-[#2C332E]">Für Vorschul- & Grundschulkinder (5-10 Jahre)</h2>
            </div>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">"Die Propheten-Geschichten für Kinder"</h4>
                <p className="text-sm text-[#4B5563] mb-2">Spannende Geschichten über Adam, Ibrahim, Musa, Isa und Muhammad (Friede sei mit ihnen allen). Kindgerecht erzählt mit Illustrationen.</p>
                <p className="text-sm text-[#4A5D4F]">Alter: 5-10 Jahre | ~18€</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">"Mein erstes Gebetsbuch"</h4>
                <p className="text-sm text-[#4B5563] mb-2">Anleitung zum Gebet mit Bildern, die jeden Schritt zeigen. Arabischer Text mit deutscher Übersetzung und Lautschrift.</p>
                <p className="text-sm text-[#4A5D4F]">Alter: 5-9 Jahre | ~14€</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">"30 Ramadan-Geschichten"</h4>
                <p className="text-sm text-[#4B5563] mb-2">Eine Geschichte für jeden Tag des Ramadan. Vermittelt Werte wie Großzügigkeit, Geduld und Dankbarkeit.</p>
                <p className="text-sm text-[#4A5D4F]">Alter: 5-10 Jahre | ~16€</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">"Die 99 Namen Allahs für Kinder"</h4>
                <p className="text-sm text-[#4B5563] mb-2">Jeder Name erklärt mit einer kurzen Geschichte und Illustration. Baut eine persönliche Beziehung zu Allah auf.</p>
                <p className="text-sm text-[#4A5D4F]">Alter: 6-12 Jahre | ~20€</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 rounded-full bg-[#D4C5A9]/30 flex items-center justify-center"><Book className="w-6 h-6 text-[#4A5D4F]" /></div>
              <h2 className="font-serif text-2xl font-medium text-[#2C332E]">Für ältere Kinder & Teenager (10+ Jahre)</h2>
            </div>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">"Der Prophet Muhammad – Sein Leben für junge Leser"</h4>
                <p className="text-sm text-[#4B5563] mb-2">Ausführliche Biographie des Propheten, altersgerecht geschrieben. Vermittelt historischen Kontext und zeitlose Lehren.</p>
                <p className="text-sm text-[#4A5D4F]">Alter: 10-16 Jahre | ~22€</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">"Quran für Jugendliche"</h4>
                <p className="text-sm text-[#4B5563] mb-2">Quran-Übersetzung mit Erklärungen, die für Jugendliche verständlich sind. Thematisch geordnet.</p>
                <p className="text-sm text-[#4A5D4F]">Alter: 12+ Jahre | ~25€</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">"Muslimische Vorbilder der Geschichte"</h4>
                <p className="text-sm text-[#4B5563] mb-2">Geschichten über muslimische Wissenschaftler, Entdecker und Helden. Inspirierend und lehrreich.</p>
                <p className="text-sm text-[#4A5D4F]">Alter: 10-16 Jahre | ~18€</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Aktivitätsbücher & Malbücher</h2>
            <div className="space-y-4">
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">"Islamisches Malbuch"</h4>
                <p className="text-sm text-[#4B5563]">Moscheen, Muster, Kalligraphie zum Ausmalen. Fördert Kreativität und Verbindung zur islamischen Kunst.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">"Arabisch lernen mit Spaß"</h4>
                <p className="text-sm text-[#4B5563]">Arbeitshefte zum Schreiben der arabischen Buchstaben. Mit Übungen und Spielen.</p>
              </div>
              <div className="bg-[#F5F5F0] rounded-xl p-5">
                <h4 className="font-medium text-[#2C332E] mb-2">"Ramadan-Tagebuch für Kinder"</h4>
                <p className="text-sm text-[#4B5563]">30 Seiten zum Ausfüllen – tägliche Reflexionen, gute Taten und Dankbarkeit.</p>
              </div>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Tipps zum Vorlesen</h2>
            <div className="bg-[#4A5D4F]/10 rounded-xl p-6">
              <ul className="text-[#4B5563] space-y-3">
                <li><strong>Regelmäßigkeit:</strong> Jeden Abend vor dem Schlafen eine Geschichte</li>
                <li><strong>Fragen stellen:</strong> Was hast du gelernt? Was hat dir gefallen?</li>
                <li><strong>Verbinden:</strong> Beziehe die Geschichten auf den Alltag</li>
                <li><strong>Mitgestalten:</strong> Lass Kinder die Bilder beschreiben</li>
                <li><strong>Bibliothek aufbauen:</strong> Eine kleine islamische Kinderbibliothek sammeln</li>
              </ul>
            </div>
          </section>

          <section className="mb-12">
            <h2 className="font-serif text-2xl font-medium text-[#2C332E] mb-6">Fazit</h2>
            <p className="text-[#4B5563] leading-relaxed mb-4">Bücher sind Fenster zu neuen Welten – und islamische Kinderbücher öffnen Türen zum Glauben. Das richtige Buch zur richtigen Zeit kann einen bleibenden Eindruck hinterlassen und die islamische Identität stärken.</p>
            <p className="text-xl text-[#4A5D4F] font-medium">Eid Mubarak! 🌙</p>
          </section>

          <div className="bg-[#F5F5F0] rounded-2xl p-6 mb-8">
            <h3 className="font-serif text-lg font-medium text-[#2C332E] mb-4">Weitere Artikel</h3>
            <ul className="space-y-2">
              <li><Link to="/ratgeber/25-geschenke-kinder" className="text-[#4A5D4F] hover:underline">→ 25 beste Eid Geschenke für Kinder</Link></li>
              <li><Link to="/ratgeber/ramadan-aktivitaeten-kinder" className="text-[#4A5D4F] hover:underline">→ Ramadan Aktivitäten für Kinder</Link></li>
            </ul>
          </div>

          <div className="bg-[#4A5D4F] rounded-2xl p-8 text-center">
            <h3 className="font-serif text-2xl font-medium text-white mb-4">Kinderprodukte entdecken</h3>
            <Link to="/geschenke/kinder" className="inline-flex items-center gap-2 bg-white text-[#4A5D4F] px-8 py-3 rounded-full font-medium hover:bg-[#D4C5A9] transition-colors">Jetzt stöbern<Gift className="w-5 h-5" /></Link>
          </div>
        </div>
      </article>
    </main>
  );
}
